module.exports = __webpack_public_path__ + "static/media/long-arrow-left.be8f804a.svg";